import { render } from "./HomeProfile.vue?vue&type=template&id=67d180df&scoped=true"
import script from "./HomeProfile.vue?vue&type=script&lang=js"
export * from "./HomeProfile.vue?vue&type=script&lang=js"

import "./HomeProfile.vue?vue&type=style&index=0&id=67d180df&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d180df"]])

export default __exports__